module.exports = new __parcel__URL__("shop_whitelist_button.80449378.png").toString();